import { render, staticRenderFns } from "./DeviceSyncConfigBtn.vue?vue&type=template&id=70c67d7a&"
import script from "./DeviceSyncConfigBtn.vue?vue&type=script&lang=ts&"
export * from "./DeviceSyncConfigBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports